export default __webpack_public_path__ + "static/media/workflow.22da2c76.png";